export default __webpack_public_path__ + "static/18-d73ec84e587864f60fd6769c217915d6.jpg";